// extracted by mini-css-extract-plugin
export default {"footerText":"Footer_footerText__oR7Uz"};